<template>
  <div class="class-emotion-rank">
    <!--标题行：左标题 + 右查看详情-->
    <div class="flex-between" style="margin-bottom: 15px">
      <span class="card-title">{{ title }}</span>
    </div>
    <!--top3 表格-->
    <TableList
      style="width: 100%"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :pagination="tablePagination"
      :rowKey="rowKey"
      :scroll="{}"
      @change="handleTableChange"
    >
      <!--变化幅度：上升蓝色箭头 / 下降紫色箭头-->
      <template #diffValue="{ text }">
        <span v-if="Number(text) > 0" class="diff-up">
          <a-icon type="arrow-up" style="font-size: 12px" />
          {{ Math.abs(Number(text)) }}
        </span>
        <span v-else-if="Number(text) < 0" class="diff-down">
          <a-icon type="arrow-down" style="font-size: 12px" />
          {{ Math.abs(Number(text)) }}
        </span>
        <span v-else>与上月持平</span>
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from '@comp/chart/TableList.vue'

// 表格列配置（卡片与详情弹框共用同一结构）
export const classEmotionColumns = [
  { title: '年级', dataIndex: 'gradeName', width: '15%' },
  { title: '班级', dataIndex: 'className', width: '40%' },
  { title: '情绪指数', dataIndex: 'avgValue', width: '20%' },
  {
    title: '变化幅度（较上月）',
    dataIndex: 'diffValue',
    width: '25%',
    scopedSlots: { customRender: 'diffValue' },
  },
]

export default {
  name: 'ClassEmotionRank',
  components: {
    TableList,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: [String, Function],
      default: 'className',
    },
    // 分页配置：传对象可覆盖默认值（如 total / current / pageSize），传 false 关闭分页
    pagination: {
      type: [Object, Boolean],
      default: () => ({}),
    },
    // 默认每页条数
    defaultPageSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      columns: classEmotionColumns,
    }
  },
  computed: {
    // 合并默认分页参数
    tablePagination() {
      if (this.pagination === false) {
        return false
      }
      return {
        size: 'small',
        current: 1,
        pageSize: this.defaultPageSize,
        pageSizeOptions: ['5', '10', '20', '50'],
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: (total) => `共 ${total} 条`,
        ...this.pagination,
      }
    },
  },
  methods: {
    // 分页/排序/筛选变化，抛出分页参数（pageNo / pageSize）供父级请求使用
    handleTableChange(pagination) {
      this.$emit('change', pagination)
      this.$emit('pageChange', {
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      })
    },
  },
}
</script>

<style scoped lang="less">
.class-emotion-rank {
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  background-color: #f9fafb;
  .card-title {
    font-weight: bold;
    color: #262626;
  }
  .view-detail {
    color: #3ba1f5;
    font-size: 13px;
    cursor: pointer;
  }
  /deep/ .ant-table-thead > tr > th {
    background-color: #f9fafb;
    color: #333;
    font-weight: bold;
  }
  /deep/ .ant-table-tbody > tr > td {
    background-color: #fff;
  }
  .diff-up {
    color: #3ba1f5;
    font-weight: 500;
  }
  .diff-down {
    color: #9254de;
    font-weight: 500;
  }
}
</style>
